import React from 'react';
import ReactDOM from 'react-dom';
import LayerSwitcherButton from "../../components/map/controls/LayerSwitcherButton";

/**
 * Implements layer switcher custom control
 */
export class LayerSwitcherControl {
    onAdd(map){
        this.map = map;
        this.container = document.createElement('div');
        this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group my-custom-control';
        ReactDOM.render(
            <LayerSwitcherButton/>,
            this.container
        );
        return this.container;
    }
    onRemove(){
        this.container.parentNode.removeChild(this.container);
        this.map = undefined;
    }
}

